import React from 'react';
import { withRouter, useParams } from 'react-router-dom';

import { session } from 'services/session';

import MerchantPerformanceOverview from './merchant-performance-overview';
import StrategyPerformance from './strategy-performance';

function CampaignTracking(props) {
	const params = useParams();
	const strategyId = params.strategyId;
	const merchId = session.orgId;

	const campaignPage = strategyId ? (
		<StrategyPerformance
			strategyId={strategyId}
		/>
	) : (
		<MerchantPerformanceOverview
			merchId={merchId}
			history={props.history}
			location={props.location}
			match={props.match}
		/>
	);

	return (
		<div className="campaign-tracking">
			{campaignPage}
		</div>
	);
}

export default withRouter(CampaignTracking);
